/**
 * 判断字符串是否为可跳转的 URL
 */
export const isUrl = (str) => {
  try {
    const url = new URL(str);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};
